import { fetchAndParse } from '../lib/utils';
import { ChangeRequest } from '../types/ChangeRequest';
import { ChangeRequestReview } from '../types/ChangeRequestReview';
import { ChangeRequestSubmission } from '../types/ChangeRequestSubmission';
import { ClientConfig } from '../types/ClientConfig';
import { BaseClient, Endpoints, getHeaders } from './BaseClient';

export const ChangeRequestClient = (config: ClientConfig) => {
    const { accessToken, param = '' } = config;
    const headers = getHeaders(accessToken);

    /**
     * Gets all change requests that are pending (pending state is based on status of fuel transaction that is either pending, approved or rejected).
     */
    const getChangeRequestSubmissions = (): Promise<ChangeRequestSubmission[]> => {
        return fetchAndParse<ChangeRequestSubmission[]>(
            `${BaseClient({ useAdminRoute: true }).getApiUrl(Endpoints.FUEL_TRANSACTION)}/changerequests/pending`,
            {
                headers,
            },
        );
    };

    const getChangeRequests = (): Promise<ChangeRequest[]> => {
        return fetchAndParse<ChangeRequest[]>(
            `${BaseClient({ useAdminRoute: false }).getApiUrl(Endpoints.FUEL_TRANSACTION)}/changerequests/${param}`,
            {
                headers,
            },
        );
    };

    const reviewChangeRequest = (data: ChangeRequestReview): Promise<Response> => {
        return fetch(`${BaseClient({ useAdminRoute: true }).getApiUrl(Endpoints.FUEL_TRANSACTION)}/changerequests`, {
            method: 'POST',
            headers,
            body: JSON.stringify({ ...data }),
        });
    };

    return {
        reviewChangeRequest,
        getChangeRequestSubmissions,
        getChangeRequests,
    };
};
